// Fallback for when the HTTP fetch of the matching file under
// src/assets/data/print-labels-data/sheet/ fails. GENERATED FROM THAT FILE - keep
// the two identical: a drifted copy means a fetch failure quietly prints a
// different label, which is the worst moment to find the difference.
export const DEFAULT_QR_SHEET_TEMPLATE: string = `
<!--
  Full-sheet copier label WITH QR CODE. ONE OF THESE PRINTS PER PHYSICAL
  CONTAINER. Used whenever PrintService.usesQrSheet is true — item rows exist
  and QR is on for this facility. See large-label-template.html for the QR-less
  twin, used otherwise.

  {{containerCaption}} ("BOX 2 of 3") and {{itemQr}} are filled per item by
  PrintService.fillItemSlots. A mixed delivery ("3 box + 2 pallet") numbers each
  container type separately, so {{containerCaption}} always reads as THIS item's
  own type and position — never a delivery-wide count.

  contact-line and qty-units-line keep the label-line class so
  PrintService.resizeFont's text-fit pass reaches them like every other line;
  .sheet-qr is sized and shrunk separately, same as its QR-less twin.
-->
<div class="label">
  <div class="label-line line-1">{{jobName}}</div>
  <div class="label-line line-2">JOB# {{jobNumber}}</div>
  <div class="label-line line-3">{{dateIn}}</div>
  <div class="label-line line-4">PO# {{poNumber}}</div>
  <div class="qr-code-line">
    <div class="left">
      <div class="label-line qty-units-line">{{containerCaption}}</div>
      <div class="label-line contact-line">{{contact}}</div>
    </div>
    <div class="right">
      <div class="sheet-qr">{{itemQr}}</div>
    </div>
  </div>
</div>
`;
